<template>
  <el-dialog
    class="orderDialog"
    title="通知公告"
    v-show="dialog"
    :visible.sync="dialog"
    width="40%"
    append-to-body
    :close-on-click-modal="false"
    @close="readClose"
  >
    <el-descriptions :column="1" :labelStyle="labelStyle">
      <el-descriptions-item label="消息类型">{{
        formData.noticeType == '1' ? '通知' : formData.noticeType == '2' ? '运营推广' : '其他'
      }}</el-descriptions-item>
      <el-descriptions-item label="时间">{{ formData.deliveryTime }}</el-descriptions-item>
      <el-descriptions-item label="消息内容"> <div v-html="formData.noticeContent"></div></el-descriptions-item>
    </el-descriptions>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" type="primary" @click="readClose">知道了</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { lastNotice } from '@/api/messageCenter/message'
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialog: this.dialogVisible,
      //label样式
      labelStyle: {
        width: '88px',
        justifyContent: 'flex-end'
      },
      formData: {
        address: '',
        name: ''
      }
    }
  },
  watch: {
    dialogVisible(val) {
      this.dialog = val
    }
  },

  created() {
    // this.messageShow()
  },
  methods: {
    messageShow() {
      lastNotice().then((res) => {
        this.formData = JSON.parse(JSON.stringify(res.data))
        if (this.formData !== null) {
          this.formData.noticeContent = this.formData.noticeContent.replace(
            /\<img/gi,
            '<img style="max-width:50%;height:auto" '
          )
        }
      })
    },
    //已读
    readClose() {
      this.$emit('close')
      // this.dialogVisible=false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/dialog.scss';
.orderDialog {
  ::v-deep .el-dialog {
    max-height: 70% !important;
  }
}
::v-deep .el-descriptions--medium:not(.is-bordered) .el-descriptions-item__cell {
  padding-bottom: 20px;
}
::v-deep .el-descriptions {
  font-size: 12px !important;
}

::v-deep .el-descriptions-item__content {
  margin-left: 30px;
}
</style>
